import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CreateClientModal from '../components/client/CreateClient';
import DeleteClientModal from '../components/client/DeleteClient';
import DetailClientModal from '../components/client/DetailClient';
import UpdateClientModal from '../components/client/UpdateClient';

export default function ClientManagement() {
    const [clients, setClients] = useState([]);
    const [filteredClients, setFilteredClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [filterStatus, setFilterStatus] = useState(''); // Novo filtro por status
    const [sortOption, setSortOption] = useState(''); // Opção de ordenação
    const clientsPerPage = 12;

    const [isModalDetalheOpen, setIsModalDetalheOpen] = useState(false);
    const [isModalCadastroOpen, setIsModalCadastroOpen] = useState(false);
    const [isModalDeleteOpen, setIsModalDeletionOpen] = useState(false);
    const [isModalUpdateOpen, setIsModalUpdateOpen] = useState(false);

    useEffect(() => {
        const consultarCliente = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/clientRoutes/clientes`);
                if (Array.isArray(response.data)) {
                    setClients(response.data);
                    setFilteredClients(response.data);
                } else {
                    console.error('Erro: dados de clientes não são um array.');
                }
            } catch (error) {
                console.error('Error fetching clients:', error);
            }
        };

        consultarCliente();
    }, []);

    const consultarCliente = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/clientRoutes/clientes`);
            setClients(response.data);
            setFilteredClients(response.data);
        } catch (error) {
            console.error('Error fetching clients:', error);
        }
    };

    const handleUpdateClient = async (updatedClientData) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/clientRoutes/clientes/${updatedClientData.id}`, updatedClientData);

            if (response && response.data) {
                setClients((prevClients) => {
                    const index = prevClients.findIndex((client) => client.id === updatedClientData.id);

                    if (index !== -1) {
                        const updatedClients = [...prevClients];
                        updatedClients[index] = response.data;

                        filterAndSortClients(updatedClients, searchTerm, filterStatus, sortOption);
                        return updatedClients;
                    }

                    return prevClients;
                });

                setFilteredClients((prevClients) => {
                    return prevClients.map((client) =>
                        client.id === updatedClientData.id ? response.data : client
                    );
                });

                setIsModalUpdateOpen(false);
            } else {
                console.error('Erro: resposta da API não contém os dados atualizados.');
            }
        } catch (error) {
            console.error('Erro ao atualizar cliente:', error);
        }
    };

    const handleSelectClientForUpdate = (client) => {
        setSelectedClient(client);
        setIsModalUpdateOpen(true); // Abrir o modal de atualização
    };

    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        setSearchTerm(term);
        filterAndSortClients(clients, term, filterStatus, sortOption);
        setCurrentPage(1);
    };

    const handleFilterStatus = (e) => {
        const status = e.target.value;
        setFilterStatus(status);
        filterAndSortClients(clients, searchTerm, status, sortOption);
    };

    const handleSortChange = (e) => {
        const option = e.target.value;
        setSortOption(option);
        filterAndSortClients(clients, searchTerm, filterStatus, option);
    };

    const filterAndSortClients = (clients, searchTerm, status, sortOption) => {
        let filtered = clients;

        // Filtrar por nome
        if (searchTerm) {
            filtered = filtered.filter((client) =>
                client.nome.toLowerCase().includes(searchTerm)
            );
        }

        // Filtrar por status
        if (status) {
            filtered = filtered.filter((client) => client.status_projeto === status);
        }

        // Ordenar os resultados
        if (sortOption === 'valorCrescente') {
            filtered = filtered.sort((a, b) => a.valor_projeto - b.valor_projeto);
        } else if (sortOption === 'valorDecrescente') {
            filtered = filtered.sort((a, b) => b.valor_projeto - a.valor_projeto);
        } else if (sortOption === 'idCrescente') {
            filtered = filtered.sort((a, b) => a.id - b.id);
        } else if (sortOption === 'idDecrescente') {
            filtered = filtered.sort((a, b) => b.id - a.id);
        }

        setFilteredClients(filtered);
    };

    const formatarParaBRL = (valor)  => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        }).format(valor);
    }

    const handleSelectClient = (client) => {
        setSelectedClient(client);
        setIsModalDetalheOpen(true);
    };

    const handleDeleteClient = (client) => {
        setSelectedClient(client);
        setIsModalDeletionOpen(true);
    };

    const handleCloseDetailModal = () => setIsModalDetalheOpen(false);
    const handleOpenCreateModal = () => setIsModalCadastroOpen(true);
    const handleCloseCreateModal = () => setIsModalCadastroOpen(false);
    const handleCloseDeleteModal = () => setIsModalDeletionOpen(false);
    const handleCloseUpdateModal = () => setIsModalUpdateOpen(false);

    const indexOfLastClient = currentPage * clientsPerPage;
    const indexOfFirstClient = indexOfLastClient - clientsPerPage;
    const currentClients = filteredClients.slice(indexOfFirstClient, indexOfLastClient);

    const totalPages = Math.ceil(filteredClients.length / clientsPerPage);

    const goToPage = (page) => setCurrentPage(page);

    const renderStatus = (status) => {
        const baseClass =
            'px-2 py-1 rounded-md text-sm font-semibold flex items-center space-x-1';
        switch (status) {
            case 'Novo':
                return (
                    <span className={`${baseClass} bg-blue-100 text-blue-700`}>
                        🟦 <span>Novo</span>
                    </span>
                );
            case 'Em Andamento':
                return (
                    <span className={`${baseClass} bg-yellow-100 text-yellow-700`}>
                        🟨 <span>Em Andamento</span>
                    </span>
                );
            case 'Concluído':
                return (
                    <span className={`${baseClass} bg-green-100 text-green-700`}>
                        🟩 <span>Concluído</span>
                    </span>
                );
            case 'Recusado':
                return (
                    <span className={`${baseClass} bg-red-100 text-red-700`}>
                        🟥 <span>Recusado</span>
                    </span>
                );
            default:
                return (
                    <span className={`${baseClass} bg-gray-100 text-gray-700`}>
                        ❔ <span>Desconhecido</span>
                    </span>
                );
        }
    };



    return (
        <div className="p-4 md:p-8 animate-fade-in max-w-7xl mx-auto">
            <div className="flex flex-col mb-8">
                <h1 className="text-3xl font-serif text-white font-bold tracking-wide">Gerenciamento de Clientes</h1>
                <p className="text-gray-400 mt-2 text-sm">Visualize, crie e administre sua base de clientes</p>
            </div>

            <div className="glass-panel p-6 mb-8">
                <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 w-full md:w-auto">
                        <input
                            type="text"
                            placeholder="Buscar clientes..."
                            value={searchTerm}
                            onChange={handleSearch}
                            className="glass-input w-full md:w-72"
                        />
                    </div>

                    <div className="w-full md:w-auto">
                        <button
                            onClick={handleOpenCreateModal}
                            className="glass-button w-full md:w-auto flex items-center justify-center"
                        >
                            <span className="text-xl mr-2">+</span> Cliente
                        </button>
                    </div>
                </div>
            </div>

            <div className="glass-panel overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="glass-table">
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th className="w-1/4">Nome</th>
                            <th className="w-1/4">Telefone</th>
                            <th className="text-center">Ações</th>
                        </tr>
                        </thead>
                        <tbody className="text-gray-200 text-sm">
                        {currentClients.map((client) => (
                            <tr key={client.id}>
                                <td>{client.id}</td>
                                <td className="font-medium text-white">{client.nome}</td>
                                <td>{client.telefone}</td>
                                <td>
                                    <div className="flex justify-center space-x-2">
                                        <button
                                            onClick={() => handleSelectClient(client)}
                                            className="text-blue-400 hover:text-blue-300 p-2 rounded-lg hover:bg-blue-400/10 transition-colors"
                                            title="Detalhes"
                                        >
                                            Detalhes
                                        </button>
                                        <button
                                            onClick={() => handleSelectClientForUpdate(client)}
                                            className="text-amber-400 hover:text-amber-300 p-2 rounded-lg hover:bg-amber-400/10 transition-colors"
                                            title="Atualizar"
                                        >
                                            Editar
                                        </button>
                                        <button
                                            onClick={() => handleDeleteClient(client)}
                                            className="text-red-400 hover:text-red-300 p-2 rounded-lg hover:bg-red-400/10 transition-colors"
                                            title="Excluir"
                                        >
                                            Excluir
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="flex justify-center items-center mt-8 space-x-2 pb-8">
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => goToPage(index + 1)}
                        className={`w-10 h-10 rounded-full flex items-center justify-center font-medium transition-all ${
                            currentPage === index + 1
                                ? 'bg-primary text-white shadow-lg border border-primary/50'
                                : 'bg-white/5 text-gray-400 hover:bg-white/10 border border-white/5 hover:text-white'
                        }`}
                    >
                        {index + 1}
                    </button>
                ))}
            </div>

            {/* Modal de Cadastro */}
            {isModalCadastroOpen && (
                <CreateClientModal onClose={handleCloseCreateModal} onUpdateScreen={consultarCliente} />
            )}

            {/* Modal de Detalhe */}
            {isModalDetalheOpen && (
                <DetailClientModal
                    onClose={handleCloseDetailModal}
                    client={selectedClient}
                    onUpdateScreen={consultarCliente}
                />
            )}

            {/* Modal de Exclusão */}
            {isModalDeleteOpen && (
                <DeleteClientModal
                    onClose={handleCloseDeleteModal}
                    client={selectedClient}
                    onUpdateScreen={consultarCliente}
                />
            )}

            {/* Modal de Atualização */}
            {isModalUpdateOpen && (
                <UpdateClientModal
                    client={selectedClient}
                    onClose={handleCloseUpdateModal}
                    onUpdateClient={handleUpdateClient}
                />
            )}
        </div>
    );
}
